// import fetch from 'isomorphic-fetch';
import store from '../store';
import nvStorage from './storage';
export const restAPIBase = () => {
    const storeApiBase = store.getState().branding.apiRoot;
    // If we haven't got an API base, or we're in development
    if (process.env.NODE_ENV === 'development' ||
        (process.env.PLATFORM === 'electron' && !storeApiBase)) {
        return 'https://pbx.sipcentric.com/api/v1';
    }
    return `${storeApiBase}/api/v1`;
};
export const nvFetch = (endpoint, options = {}) => {
    var _a;
    const url = restAPIBase() + (endpoint.startsWith('/') ? '' : '/') + endpoint;
    const token = options.token || store.getState().user.accessToken;
    const loginRedirectUrl = (_a = store.getState().branding.branding) === null || _a === void 0 ? void 0 : _a.loginRedirectUrl;
    const fetchOptions = { method: options.method };
    fetchOptions.headers = options.headers || {};
    fetchOptions.headers['X-Relationship-Key'] = 'id';
    fetchOptions.headers['X-WWW-Authenticate'] = 'false';
    if (typeof token !== 'string') {
        return fetch(url, fetchOptions);
    }
    if (!loginRedirectUrl) {
        fetchOptions.headers.Authorization = `Bearer ${token}`;
    }
    else {
        fetchOptions.credentials = 'include';
    }
    const { params } = options;
    let completeUrl = url;
    if (params) {
        // Build query param string
        const queryString = Object.keys(params)
            .reduce((prev, key) => {
            const value = params[key];
            return `${prev}${key}=${value}&`;
        }, '?')
            .slice(0, -1);
        completeUrl += queryString;
    }
    return fetch(completeUrl, fetchOptions);
};
export const clearAuthToken = () => {
    nvStorage.remove('token');
    nvStorage.remove('token-remember');
    nvStorage.remove('token-expires');
};
